import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPlant } from '../services';

// Thunk asíncrono para obtener los datos de team desde la API
export const fetchPlantData = createAsyncThunk(
    'team/fetchPlantData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchPlant(); // Llama al servicio de la API
            return data;
        } catch (error) {
            return rejectWithValue(error.message); // Manejo de errores
        }
    }
);

const plantSlice = createSlice({
    name: 'plant',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Puedes agregar más acciones sincronas si es necesario
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPlantData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPlantData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchPlantData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default plantSlice.reducer;
